import { faPhone, faVideo, faVideoSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HangUpCallIcon } from "../../SvgIcons/HangUpIcon";

interface HangUpButtonProps {
    onClick: () => void;
}

// Camera Button
const HangUpButton: React.FC<HangUpButtonProps> = ({ onClick }) => (
    <button
    onClick={onClick}
    className={`w-14 h-14 rounded-2xl text-white flex justify-center align-middle items-center text-lg transition bg-[#EB5757] hover:bg-[#c54343]`}
  >
    <HangUpCallIcon size={32}/>
  </button>
);

export default HangUpButton;